import UtilService from 'services/util';

import { isEmpty } from 'util/utils';

import { API_ROUTES } from 'constants/CommonApi';

/**
 * Fucntion used to get user list
 * @param {*} request
 */
export const getUserList = (request = {}, config = { loader: false }) =>
  UtilService.callApiAsync({ ...API_ROUTES.User.paginate, request, ...(!isEmpty(config) && { config }) });

/**
 * Function used to get user details
 * @param {*} id
 */
export const geUserDetails = async (id = null, config) =>
  UtilService.callApiAsync({
    ...UtilService.withUrlParams(API_ROUTES.User.getDetail, [id]),
    ...(!isEmpty(config) && { config }),
  });

export const syncUserManually = (request = {}, config) =>
  UtilService.callApiAsync({ ...API_ROUTES.User.manualUserSync, request, ...(!isEmpty(config) && { config }) });

/**
 * Function used to update user details
 * @param {*} id
 * @param {*} request
 */
export const updateUserDetail = async (id = null, request = {}, config) =>
  UtilService.callApiAsync({
    ...UtilService.withUrlParams(API_ROUTES.User.update, [id]),
    request,
    ...(!isEmpty(config) && { config }),
  });

/**
 *  Function used to save user details
 * @param {*} request
 */
export const storeUserDetail = (request = {}, config) =>
  UtilService.callApiAsync({ ...API_ROUTES.User.Upsert, request, ...(!isEmpty(config) && { config }) });

/**
 *  Function used to save user details
 * @param {*} request
 */
export const createMany = (request = {}, config) =>
  UtilService.callApiAsync({ ...API_ROUTES.User.createMany, request, ...(!isEmpty(config) && { config }) });

/**
 * Fucntion used to change password
 * @param {*} request
 */
export const resetPassword = (request = {}, config) =>
  UtilService.callApiAsync({ ...API_ROUTES.User.ResetPassword, request, ...(!isEmpty(config) && { config }) });
